import { batchDeleteFieldContinuationData } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { BatchDeleteInput } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchRemoveFieldContinuationData(continuationData: BatchDeleteInput[]): Promise<boolean> {
	if (continuationData.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchDeleteFieldContinuationData,
				variables: { continuationData },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			console.log("error deleting field continuation data: ", error);
			recordSentry({ error });
			return false;
		}
	}
	return true;
}

export default batchRemoveFieldContinuationData;
